import SimpleBar from 'simplebar';
const simplebarWrappers = document.querySelectorAll('.js-scroll-wrap');
if (simplebarWrappers) {
    simplebarWrappers.forEach(scrollWrap => {
        new SimpleBar(scrollWrap)
    })
}
